import { useState } from 'react';
import PropTypes from 'prop-types';
import { css, etiColors, resetButtonStyle, mediaQueries } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = css`
  background: ${etiColors.grayScale[10]};
  border-bottom: 1px solid ${etiColors.grayScale[6]};
  display: flex;
  margin: 0.313rem;
  padding: 0.625rem 0.5rem 0.25rem;

  @media ${mediaQueries.large.up} {
    flex-direction: column;
    padding: 0.75rem;
    position: absolute;
    right: 0.625rem;
    top: 0.625rem;
    z-index: 2;

    html[dir='rtl'] & {
      left: 0.625rem;
      right: auto;
    }
  }
`;
const getColor = selected => selected ? etiColors.white : etiColors.grayScale[8];
const deckOptionStyles = (selected, total) => css`
  ${resetButtonStyle};
  /* stylelint-disable order/properties-alphabetical-order */
  align-items: center;
  border-bottom: 3px solid ${getColor(selected)};
  color: ${getColor(selected)};
  display: flex;
  flex-basis: ${`${100 / total}%`};
  font-size: 0.75rem;
  font-weight: 700;
  justify-content: center;
  padding-bottom: 0.188rem;

  @media ${mediaQueries.large.up} {
    border-bottom: none;
    border-left: 3px solid ${getColor(selected)};
    justify-content: flex-start;
    padding: 0.313rem 0.313rem 0.313rem 0.5rem;

    html[dir='rtl'] & {
      border-left: 0;
      border-right: 3px solid ${getColor(selected)};
      padding-right: 0.5rem;
    }
  }
`;
const DeckSelection = _ref => {
  let {
    onValueChange,
    options,
    selected
  } = _ref;
  const [currentValue, setCurrentValue] = useState(selected);
  const handleValueChange = value => () => {
    setCurrentValue(value);
    onValueChange(value);
  };
  const generateKey = index => `deck-option-${index}`;
  return /*#__PURE__*/_jsx("div", {
    className: wrapperStyles,
    "data-testid": "seatMap-deckSelection-dropdown",
    children: options.map((option, index) => /*#__PURE__*/_jsx("button", {
      className: deckOptionStyles(currentValue.value === option.value, options.length || 0),
      onClick: handleValueChange(option),
      type: "button",
      children: option.label
    }, generateKey(index)))
  });
};
DeckSelection.propTypes = {
  onValueChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  selected: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};
export default DeckSelection;
//# sourceMappingURL=DeckSelection.js.map